import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { assetUrl } from "../../../utils/assetUrl";
import "./s.css";

const etiquetas = [
  {
    titulo: "Malbec Reserva 2019",
    imagen: "/etiquetas/Eti_MALBEC RESERVA 2019.jpg",
  },
  {
    titulo: "Cabernet Sauvignon Reserva 2020",
    imagen: "/etiquetas/Eti_CABERNET RESERVA 2020.jpg",
  },
  {
    titulo: "Corte Reserva 2019",
    imagen: "/etiquetas/Eti_CORTE 2018 RESERVA.jpg",
  },
  {
    titulo: "Petit Verdot Reserva 2018",
    imagen: "/etiquetas/Eti_PETIT VERDOT.jpg",
  },
  {
    titulo: "Cabernet Sauvignon 2021",
    imagen: "/etiquetas/Eti_CABERNET SAUVIGNON.jpg",
  },
  {
    titulo: "Malbec 2023",
    imagen: "/etiquetas/Eti_malbec 23 impr copia.jpg",
  },
  {
    titulo: "Bonarda 2023",
    imagen: "/etiquetas/Eti_Bonarda 23 impre.jpg",
  },
  {
    titulo: "Cabernet Sauvignon 2024",
    imagen: "/etiquetas/Eti_CABERNET SAUVIGNON 2024 impre copia.jpg",
  },
  {
    titulo: "Rosado de Malbec",
    imagen: "/etiquetas/Eti_Rosado de Malbec Impr-2.jpg",
  },
];

const Etiquetas = () => {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const openImage = (index) => setSelectedIndex(index);
  const closeImage = () => setSelectedIndex(null);

  const showNext = () => {
    setSelectedIndex((current) => (current + 1) % etiquetas.length);
  };

  const showPrev = () => {
    setSelectedIndex(
      (current) => (current - 1 + etiquetas.length) % etiquetas.length
    );
  };

  useEffect(() => {
    if (selectedIndex === null) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") setSelectedIndex(null);
      if (event.key === "ArrowRight") {
        setSelectedIndex((current) => (current + 1) % etiquetas.length);
      }
      if (event.key === "ArrowLeft") {
        setSelectedIndex(
          (current) => (current - 1 + etiquetas.length) % etiquetas.length
        );
      }
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedIndex]);

  const selectedEtiqueta =
    selectedIndex !== null ? etiquetas[selectedIndex] : null;

  return (
    <div className="contenedor-etiquetas">
      <div className="intro-etiquetas">
        <h1>ETIQUETAS</h1>
        <p>
          Cuando <strong>ARTE Y VINO SE HACEN UNO:</strong> nuestras raíces están
          en nuestro diálogo con el arte, un enfoque que nos hace únicos.
        </p>
        <p>
          Los vinos de Osvaldo revelan el paisaje y la cultura típica de esta
          región. Nuestras etiquetas interpretan este paisaje y su cultura, son
          fragmentos de obras del{" "}
          <strong>artista mendocino Cristian Delhez.</strong> Incansable relator
          de historias dibujadas, Cristian fue un artista plástico, grabador,
          dibujante y pintor que dejó una huella imborrable en el patrimonio
          cultural mendocino.
        </p>
        <p>
          Cristian Delhez nos compartió generosamente sus obras. Junto a su hijo
          Iván, seleccionamos algunos fragmentos de ellas para identificar
          nuestros vinos.
        </p>
        <p>
          Te invitamos a conocer más obras del{" "}
          <Link to="https://www.instagram.com/crisdelhez/" target="_blank">
            <u>artista</u>
          </Link>
          .
        </p>
      </div>

      <p className="etiquetas-hint">Deslizá para ver más etiquetas</p>

      <div className="etiquetas-carousel">
        {etiquetas.map((etiqueta, index) => (
          <button
            key={etiqueta.titulo}
            type="button"
            className="etiqueta-item"
            onClick={() => openImage(index)}
            aria-label={`Ver ${etiqueta.titulo} en grande`}
          >
            <div className="etiqueta-img-wrap">
              <img
                src={assetUrl(etiqueta.imagen)}
                alt={etiqueta.titulo}
                draggable={false}
              />
            </div>
            <h3>{etiqueta.titulo}</h3>
          </button>
        ))}
      </div>

      {selectedEtiqueta && (
        <div className="modal" onClick={closeImage} role="presentation">
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-label={selectedEtiqueta.titulo}
          >
            <button
              type="button"
              className="modal-close"
              onClick={closeImage}
              aria-label="Cerrar"
            >
              &times;
            </button>
            <button
              type="button"
              className="modal-nav modal-prev"
              onClick={showPrev}
              aria-label="Etiqueta anterior"
            >
              &#8249;
            </button>
            <div className="modal-image-wrap">
              <img
                src={assetUrl(selectedEtiqueta.imagen)}
                alt={selectedEtiqueta.titulo}
              />
              <p className="modal-caption">{selectedEtiqueta.titulo}</p>
            </div>
            <button
              type="button"
              className="modal-nav modal-next"
              onClick={showNext}
              aria-label="Siguiente etiqueta"
            >
              &#8250;
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Etiquetas;
